import Commerce from '@chec/commerce.js';

//creating a new instance of commerce and that is going to be our store 
export const commerce = new Commerce(process.env.REACT_APP_CHEC_PUBLIC_KEY, true); 